import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import {
  type LoginFormData,
  login as loginAction,
} from "@/server/actions/employers/login/login";
import { pagesPath } from "@/utils/pages-path";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

const DEFAULT_URL_AFTER_LOGIN = pagesPath.employers.$url().path;

export function useLogin() {
  const { getComebackUrl } = useComebackUrl();
  const router = useRouter();

  const login = useCallback(
    async (data: LoginFormData) => {
      const res = await loginAction(data);
      if (!res.success) {
        return res.error;
      }

      const url = getComebackUrl() ?? DEFAULT_URL_AFTER_LOGIN;
      router.push(url);
    },
    [getComebackUrl, router],
  );

  return login;
}
